namespace $ {

	export const $hyoo_dnd_spell_levels = [
		{
			charms: 0,
			spells: 0,
			slots: [],
		},
		{
			charms: 2,
			spells: 4,
			slots: [ 0, 2 ],
		},
		{
			charms: 2,
			spells: 5,
			slots: [ 0, 3 ],
		},
		{
			charms: 2,
			spells: 6,
			slots: [ 0, 4, 2 ],
		},
		{
			charms: 3,
			spells: 7,
			slots: [ 0, 4, 3 ],
		},
		{
			charms: 3,
			spells: 8,
			slots: [ 0, 4, 3, 2 ],
		},
		{
			charms: 3,
			spells: 9,
			slots: [ 0, 4, 3, 3 ],
		},
		{
			charms: 3,
			spells: 10,
			slots: [ 0, 4, 3, 3, 1 ],
		},
		{
			charms: 3,
			spells: 11,
			slots: [ 0, 4, 3, 3, 2 ],
		},
		{
			charms: 3,
			spells: 12,
			slots: [ 0, 4, 3, 3, 3, 1 ],
		},
		{
			charms: 4,
			spells: 14,
			slots: [ 0, 4, 3, 3, 3, 2 ],
		},
		{
			charms: 4,
			spells: 15,
			slots: [ 0, 4, 3, 3, 3, 2, 1 ],
		},
		{
			charms: 4,
			spells: 15,
			slots: [ 0, 4, 3, 3, 3, 2, 1 ],
		},
		{
			charms: 4,
			spells: 16,
			slots: [ 0, 4, 3, 3, 3, 2, 1, 1 ],
		},
		{
			charms: 4,
			spells: 18,
			slots: [ 0, 4, 3, 3, 3, 2, 1, 1 ],
		},
		{
			charms: 4,
			spells: 19,
			slots: [ 0, 4, 3, 3, 3, 2, 1, 1, 1 ],
		},
		{
			charms: 4,
			spells: 19,
			slots: [ 0, 4, 3, 3, 3, 2, 1, 1, 1 ],
		},
		{
			charms: 4,
			spells: 20,
			slots: [ 0, 4, 3, 3, 3, 2, 1, 1, 1, 1 ],
		},
		{
			charms: 4,
			spells: 22,
			slots: [ 0, 4, 3, 3, 3, 3, 1, 1, 1, 1 ],
		},
		{
			charms: 4,
			spells: 22,
			slots: [ 0, 4, 3, 3, 3, 3, 2, 1, 1, 1 ],
		},
		{
			charms: 4,
			spells: 22,
			slots: [ 0, 4, 3, 3, 3, 3, 2, 2, 1, 1 ],
		},
	] as { charms: number, spells: number, slots: number[] }[]
	
}
